/* global google*/

const addSearchBox = (map) => {
  // Create the search box
  const input = document.createElement('input')

  input.setAttribute('placeholder', 'Adresse suchen...')
  input.setAttribute('class', 'search')

  // hook up google search to input-element
  const searchBox = new google.maps.places.SearchBox(input)

  // push input-element to array of top-right positioned elements
  map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(input)

  // Bias the SearchBox results towards current map's viewport.
  map.addListener('bounds_changed', () => {
    searchBox.setBounds(map.getBounds())
  })

  // container array for markers
  let markers = []

  searchBox.addListener('places_changed', () => {
    const places = searchBox.getPlaces()

    // Clear out the old markers.
    markers.forEach((marker) => {
      marker.setMap(null)
    })

    // empty the markers array
    markers = []

    // For each place, get the icon, name and location.
    const bounds = new google.maps.LatLngBounds()

    places.forEach((place) => {
      const icon = {
        url: place.icon,
        size: new google.maps.Size(71, 71),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(17, 34),
        scaledSize: new google.maps.Size(25, 25)
      }

      // Create a marker for each place.
      markers.push(
        new google.maps.Marker({
          map,
          icon,
          title: place.name,
          position: place.geometry.location
        })
      )

      if (place.geometry.viewport) {
        // Only geocodes have viewport.
        bounds.union(place.geometry.viewport)
      } else {
        bounds.extend(place.geometry.location)
      }
    })

    map.fitBounds(bounds)
  })
}

export default addSearchBox



// WEBPACK FOOTER //
// ./src/mapSetup/addSearchBox.js